/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher PPI is sharper, but beyond what the eye can resolve at normal viewing distance the benefit fades while cost and power use rise.`)
};

const es_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPI más alto es más nítido, pero más allá de lo que el ojo puede distinguir a una distancia de visión normal, el beneficio disminuye mientras el coste y el consumo aumentan.`)
};

const de_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein höherer PPI-Wert ist schärfer, doch jenseits dessen, was das Auge bei normalem Betrachtungsabstand auflösen kann, nimmt der Nutzen ab, während Kosten und Energieverbrauch steigen.`)
};

const nl_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een hogere PPI is scherper, maar voorbij wat het oog op normale kijkafstand kan onderscheiden neemt het voordeel af terwijl kosten en energieverbruik stijgen.`)
};

const fr_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPP plus élevé est plus net, mais au-delà de ce que l'œil peut distinguer à une distance de visionnage normale, le bénéfice s'estompe tandis que le coût et la consommation augmentent.`)
};

const it_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPI più alto è più nitido, ma oltre ciò che l'occhio può risolvere alla normale distanza di visione il vantaggio svanisce mentre costo e consumo energetico aumentano.`)
};

const pt_br2_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um PPI maior é mais nítido, mas além do que o olho consegue distinguir na distância normal de visualização, o benefício desaparece enquanto o custo e o consumo de energia aumentam.`)
};

const pt_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um PPI mais alto é mais nítido, mas além do que o olho consegue distinguir a uma distância de visualização normal, o benefício desvanece-se enquanto o custo e o consumo de energia aumentam.`)
};

const ja_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPIが高いほど鮮明になりますが、通常の視聴距離で目が識別できる限界を超えると効果は薄れ、一方でコストと消費電力は増加します。`)
};

const zh_ppi_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI 越高图像越清晰，但一旦超过正常观看距离下肉眼能分辨的极限，收益就会递减，而成本和功耗却会上升。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_faq_a4", locale)
	if (locale === "en") return en_ppi_faq_a4(inputs)
	if (locale === "es") return es_ppi_faq_a4(inputs)
	if (locale === "de") return de_ppi_faq_a4(inputs)
	if (locale === "nl") return nl_ppi_faq_a4(inputs)
	if (locale === "fr") return fr_ppi_faq_a4(inputs)
	if (locale === "it") return it_ppi_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_faq_a4(inputs)
	if (locale === "pt") return pt_ppi_faq_a4(inputs)
	if (locale === "ja") return ja_ppi_faq_a4(inputs)
	return zh_ppi_faq_a4(inputs)
};